import React from 'react';
import classes from "./Section.module.css"


export default function Section({ children }) {
    return (
        <section className={classes.section}>
            <div className={classes.childWrapper }>
                {children}
            </div>
        </section>

    )
}